import { render, staticRenderFns } from "./CbsCellNumber.vue?vue&type=template&id=9cf27dce&scoped=true"
import script from "./CbsCellNumber.vue?vue&type=script&lang=js"
export * from "./CbsCellNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf27dce",
  null
  
)

export default component.exports